<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M13.099 4.944c0-.521.408-.944.911-.944.503 0 .911.423.911.944v1.222c.414.131.803.366 1.13.705l6.217 6.443a2.906 2.906 0 010 4.006l-7.385 7.653a2.666 2.666 0 01-3.865 0L4.8 18.53a2.906 2.906 0 010-4.006l7.384-7.653a2.72 2.72 0 01.914-.626v-1.3zm0 5.98V8.596l-7.01 7.264a.948.948 0 00-.234.417h14.843l.281-.291a.969.969 0 000-1.335L14.921 8.37v2.554c0 .521-.408.944-.91.944-.504 0-.912-.423-.912-.944zm11.642 6.694c.134.08.244.193.322.33l2.428 4.31c1.437 2.545-.34 5.742-3.187 5.742-2.85 0-4.624-3.197-3.188-5.742l2.43-4.31a.894.894 0 01.32-.33.855.855 0 01.875 0z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsPaintBucketFilled'
}
</script>
